/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-02 17:24:06
 * @LastEditTime: 2019-11-26 16:02:45
 * @LastEditors: Please set LastEditors
 */
// import { District } from "../../model/District";
// import { OLLayerUtility } from "../../../../utility/common/OLLayerUtility";

export class DistrictLayer {
  constructor() {
    this.curMap = null;
  }


  location(district) {
    if (!district) return;
    // let districtExtent = district.extent;
    let centerX =district.centerX;// (districtExtent[0] + districtExtent[2]) / 2;
    let centerY =district.centerY;// (districtExtent[1] + districtExtent[3]) / 2;
    let mapLevel = district.level;
    // let code = district.code;
    // if (code) {
    //   if (code.endsWith("0000") || code.length === 2) {
    //     mapLevel = 9;
    //   }
    //   else if (code.endsWith("00")) {
    //     mapLevel = 11;
    //   }
    //   else if (code.length === 6) {
    //     mapLevel = 13
    //   }
    // }

    let olPoint = new Array();
    olPoint.push(centerX, centerY);

    this.curMap.getView().setZoom(mapLevel);
    this.curMap.getView().setCenter(olPoint);


    // let districtBound = district.bound;
    // let boundSplitInfo = districtExtent.split(",");
    // let mapExtentCoors=new Array();
    // mapExtentCoors.push(parseFloat(boundSplitInfo[0]));
    // mapExtentCoors.push(parseFloat(boundSplitInfo[3]));
    // mapExtentCoors.push(parseFloat(boundSplitInfo[2]));
    // mapExtentCoors.push(parseFloat(boundSplitInfo[1]));

    // let mapView = this.curMap.getView();
    // mapView.fit(districtExtent, {
    //   nearest: true
    // });

    // this.curMap.getView().setZoom(zoom);
    // this.curMap.getView().setCenter(centerPnt);


  }




}